export class QualityControlCathodic {
    id!: string
    job!: string
    sacrificialAnodeBagSize!: string
    installationLocation!: string
    numberOfAnodeBags!: string
    testStationTypeAndLocation!: string
    createdOn!: Date
    modifiedOn!: Date
}
